export default {
  slug: "jetbrains-net",
  code: "DN",
  label: "JetBrains .NET",
  shortLabel: ".NET",
  altLabel: ".NET Tools",
  isDotNet: true,
  hideProductName: true,
  hasLogo: false,
  krakenDir: "dotNet",
  thumbnailColor: "#FF45ED",
  logoFamily: "dotnet",
};
